import { forwardRef } from 'react';

import { classesBuilder } from '@common/helpers';
import ArrowButton from '@components/Button/ArrowButton';

import { formatSectionId } from '../helpers';
import type { ISidebarNavItemProps } from './types';

import style from '../styles.module.scss';

const SidebarNavItem = forwardRef<HTMLLIElement, ISidebarNavItemProps>(
  ({ section, isActive = false, isMobile = false, onClick }, ref) => {
    return (
      <li
        ref={ref}
        className={classesBuilder(style.item, { [style.active]: isActive })}
        onClick={onClick}
      >
        <span className={style['item-title']}>{formatSectionId(section.id)}</span>
        {isMobile && (
          <ArrowButton
            className={style['item-arrow']}
            direction="right"
            scale={0.4}
          />
        )}
      </li>
    );
  }
);

SidebarNavItem.displayName = 'SidebarNavItem';

export default SidebarNavItem;
